import React from 'react';
import config from 'config/api';
// import ReactDOM from 'react-dom';
import queryString from 'query-string';
import { connect } from 'react-redux';
import Immutable from 'immutable';
import clsx from 'clsx';
// import {
//   Redirect,
// } from 'react-router-dom'
import Typography from '@material-ui/core/Typography';
import Form from 'components/UI/Form/Form';
import {
  send as formSubmitAction,
  hasSentFailed as isFormErrored,
  getLog as getFormLog,
  getError as getFormError,
  isSending as isFormRunning,
  isSent as isFormComplete,
  getData,
  clearData,
} from './ducks/rpps';
import { orangeTheme } from 'components/ThemeAlt';
import { getCurrentUser } from 'ducks/authentication';
import {
  withStyles,
  // createMuiTheme,
  ThemeProvider,
} from '@material-ui/core/styles';
const FIELDS_FULL = [
  {
    id: 'accountLastname',
    name: 'accountLastname',
    label: 'Nom',
    validation: ['notEmpty', 'alphaNum'],
    maxLength: 64,
    sizes: {
      xs: 6,
      md: 4,
    },
  },
  {
    id: 'accountFirstname',
    name: 'accountFirstname',
    label: 'Prénom',
    validation: ['notEmpty', 'alphaNum'],
    maxLength: 64,
    sizes: {
      xs: 6,
      md: 4,
    },
  },
  {
    id: 'accountRpps',
    name: 'accountRpps',
    label: 'RPPS',
    validation: ['notEmpty', 'num'],
    minLength: 11,
    maxLength: 11,
    sizes: {
      xs: 12,
      md: 4,
    },
  },
];
const styles = (theme) => {
  return {
    root: {
      backgroundColor: theme.palette.primary.main,
      padding: '30px 30px 20px',
      margin: '0 auto 20px',
      width: '100%',
      color: '#fff',
      '& .MuiTypography-h4': {
        marginBottom: theme.spacing(3) + 'px !important',
      },
      '& .MuiTypography-body1': {
        color: '#fff',
      },
      '& .MuiTypography-caption': {
        color: theme.palette.text.light,
      },
    },
    form: {
      maxWidth: 1024,
      margin: '0 auto',
    },
  };
};
const CONFIG = {
  // btCancel: true,
  // btCancelLabel: 'Retour'
  fieldVariant: 'filled',
};
class RPPSForm extends Form {
  constructor(props) {
    super(props);
    this.state = {};
    // let $$FIELDS;
    this.$$FIELDS = Immutable.fromJS(FIELDS_FULL);
    this.$$CONFIG = Immutable.fromJS(CONFIG);
    // this._onSubmit = this._onSubmit.bind(this);
    // this.$$FIELDS = $$FIELDS;
    // this._onFormSubmit = this._onFormSubmit.bind(this);
    // this._onFieldValueChange = this._onFieldValueChange.bind(this);
  }
  componentDidMount() {
    this._setupState();
    this._mapRawValues(this.props.$$formValues);
  }
  componentDidUpdate(oldProps) {
    // console.log(oldProps)
    // if((oldProps.isFormComplete !== true && this.props.isFormComplete === true && this.props.$$data !== undefined) ||
    //   (oldProps.$$data !== true && this.props.$$data === true && this.props.isFormComplete === true)) {
    if (oldProps.isFormComplete !== true && this.props.isFormComplete === true) {
      // clearData();
      this._onFormComplete();
    }
  }
  componentWillUnmount() {
    this.props.clearData();
  }
  _onFormComplete() {
    // console.log('FORM IS COMPLETE !!')
    // console.log(this.props.$$data)
    const { $$data, clearData, onFormComplete } = this.props;
    onFormComplete({
      values: $$data,
    });
    clearData();
  }
  _mapRawValues($$values) {
    if ($$values === undefined || !$$values.get) return;
    var o = {};
    // return Immutable.fromJS(o);
    // return $$values;
    // var tmp = {}
    // $$values.map((val, k) => {
    Immutable.fromJS(o).map((val, k) => {
      this._onFieldValueChange(null, {
        id: k,
        value: val,
      });
      return true;
    });
    // return $$values;
    return Immutable.fromJS(o);
  }
  // _onSubmit(formData) {
  // this.props.onFormComplete({
  //   values: formData
  // });
  // }
  _getI18n() {
    this.i18n = {
      send: 'Valider',
      sending: 'Envois...',
    };
  }
  render() {
    const {
      // error,
      // loading,
      classes,
      className,
      log,
      isFormComplete,
      // userRole,
    } = this.props;
    //
    // if (isFormComplete) {
    //   const url ='/contact'
    //   return <Redirect to={{
    //       pathname: url,
    //       state: { from: this.props.location }
    //     }}/>
    //   }
    return (
      <div className={clsx(classes.root, className)}>
        <div className={classes.form}>
          <Typography variant="h4" gutterBottom>
            J’ai reçu l’invitation du laboratoire GSK et j’ai un numéro RPPS
          </Typography>
          <ThemeProvider theme={orangeTheme}>
            <If condition={!isFormComplete}>{this._renderForm()}</If>
            <If condition={isFormComplete}>
              <Typography variant="h5" gutterBottom>
                {log}
              </Typography>
            </If>
            <Typography variant="caption" gutterBottom>
              La saisie de votre code RPPS nous permettra de vérifier votre qualité de professionnel de santé
            </Typography>
          </ThemeProvider>
        </div>
      </div>
    );
  }
}
const mapStateToProps = ($$state) => {
  return {
    isFormErrored: isFormErrored($$state),
    log: getFormLog($$state),
    $$data: getData($$state),
    error: getFormError($$state),
    loading: isFormRunning($$state),
    isFormComplete: isFormComplete($$state),
    $$formValues: getCurrentUser($$state),
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    onSubmit: (formData) => {
      dispatch(formSubmitAction(formData));
    },
    clearData: () => {
      dispatch(clearData());
    },
  };
};
export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(RPPSForm));



// WEBPACK FOOTER //
// ./src/components/Registration/RPPSForm.jsx